import {
  Text,
  TooltipRenderer,
  Box,
  Inline,
  IconRenderer,
} from 'braid-design-system';
import { vars } from 'braid-design-system/css';
import type { ComponentProps } from 'react';

import { useLazyColorMode } from '#src/components/ColorModeProvider/ColorModeProvider.tsx';

const SeekPassIconVerifiedDark =
  'https://integration.seek.com/assets/verify-with-seek-pass/verified-icons/verified-dark.svg';
const SeekPassIconVerifiedLight =
  'https://integration.seek.com/assets/verify-with-seek-pass/verified-icons/verified-light.svg';

export const Icon = (props: ComponentProps<typeof Box>) => {
  const lazyColorMode = useLazyColorMode();
  const icon =
    lazyColorMode?.colorMode === 'darkMode'
      ? SeekPassIconVerifiedDark
      : SeekPassIconVerifiedLight;
  return (
    <Box
      alt="SEEK Pass verified icon"
      component="img"
      src={icon}
      aria-hidden="true"
      {...props}
    />
  );
};

export const SeekPassIdVerifiedIndicator = ({
  idSuffix,
  name,
}: {
  idSuffix: string;
  name?: string;
}) => (
  <Inline space="xxsmall" alignY="center">
    <TooltipRenderer
      id={`seekpass-verified-indicator-tooltip-${idSuffix}`}
      tooltip={
        <Text>{`Verified by SEEK Pass${name ? ` as ${name}` : ''}`}</Text>
      }
    >
      {({ triggerProps }) => (
        <Box display="flex" justifyContent="center" {...triggerProps}>
          <Icon />
        </Box>
      )}
    </TooltipRenderer>
  </Inline>
);

export const SeekPassLegend = ({
  background,
}: {
  background?: ComponentProps<typeof Box>['background'];
}) => {
  const lazyColorMode = useLazyColorMode();
  return (
    <Box
      background={background || 'promoteLight'}
      paddingX="small"
      paddingY="xsmall"
      borderRadius="standard"
      display="inlineBlock"
      maxWidth="content"
    >
      <Text
        icon={
          <IconRenderer>
            {({ className }) => (
              <Icon
                className={className}
                color={vars.foregroundColor.promote}
              />
            )}
          </IconRenderer>
        }
        tone="promote"
        weight={lazyColorMode?.colorMode === 'darkMode' ? undefined : 'medium'}
      >
        Verified by SEEK Pass
      </Text>
    </Box>
  );
};
